import React from 'react';
import RenderTypeIcon from '../RenderTypeIcon';

const FilterValueItem = ({
  value,
  label,
  isSelected,
  isHighlighted,
  onMouseEnter,
  onCheckboxChange,
  onValueClick
}) => {
  const lowerCaseLabel = typeof label === 'string' ? label.toLowerCase() : '';

  return (
    <li
      className={`flex capitalize items-center gap-2 w-full px-1.5 py-2 text-xs md:text-[13px] leading-[15.73px] text-start ${
        isHighlighted ? 'bg-[#4d5464]' : ''
      }  border-transparent rounded-[4px] border`}
      onMouseEnter={onMouseEnter}>
      <input
        type="checkbox"
        checked={isSelected}
        onChange={onCheckboxChange}
        className="w-3 h-3 form-checkbox bg-transparent text-transparent accent-primary rounded ring ring-[#393a45] hover:ring-2 focus:outline-none focus:ring-0"
      />
      <div className={`w-full flex gap-2 cursor-default`} onClick={onValueClick}>
        <RenderTypeIcon className="w-4 h-4" type={label} />
        {lowerCaseLabel}
      </div>
    </li>
  );
};

export default FilterValueItem;
